// extracted by mini-css-extract-plugin
export default {"rowClickable":"row_rowClickable__wUKZz","rowBorder":"row_rowBorder__LNSIG"};